import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface Props {
  heading: string;
  className?: string;
  icon?: JSX.Element;
}

export default function SellerInstructionsWrapper({
  heading,
  className = '',
  icon,
  children,
}: PropsWithChildren<Props>) {
  return (
    <div
      className={classNames(
        `mb-2 ml-auto flex flex-col items-center justify-center rounded-lg border-2 border-white bg-white bg-opacity-50 px-14 py-6 ${className}`
      )}
    >
      <div className='flex items-center justify-center gap-x-4'>
        {icon ?? null}
        <div className='text-center text-h4 font-extrabold'>{heading}</div>
      </div>
      {children}
    </div>
  );
}
